/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import Analytics from '../../analytics/Analytics';
import PersistenceController from '../../persistence/PersistenceController';
import Calculator from './old_Calculator';
import { CalculatorResult, MethodType, ParameterModifier, ParameterName } from './calculatorTypes';
import { getDefaultParameters } from './configParser';

class CalculationController {
  private static _instance: CalculationController;
  public static get instance() {
    return this._instance || (this._instance = new this());
  }

  private _currentResults: CalculatorResult[] = [];

  private methodNames = ['closedSystem', 'openSystem', 'freeEvaporation'];
  public methodToIndex = (method: MethodType) => this.methodNames.indexOf(method);
  public indexToMethod = (methodIndex: number) => this.methodNames[methodIndex] as MethodType;

  private getCurrentResult(method: MethodType) {
    return this._currentResults[this.methodToIndex(method)];
  }
  private setCurrentResult(method: MethodType, value: CalculatorResult) {
    // TODO: manage persistence
    this._currentResults[this.methodToIndex(method)] = value;
    PersistenceController.store('calculatorResult', this._currentResults);
  }

  public begin(method: MethodType) {
    this._currentResults = PersistenceController.retrieve('calculatorResult', CalculatorResult);
    return this._currentResults;
  }

  public reset(method: MethodType, log: boolean = true) {
    if (log) {
      Analytics.log('calculation.reset');
    }
    const defaults = getDefaultParameters(method);
    this.setCurrentResult(method, defaults);
    return defaults;
  }

  public trimValue = (val: number) => {
    const precision = 6;
    return Number(Math.round((val + 'e' + precision) as any) + 'e-' + precision);
  };

  public calculate(method: MethodType, cardIndex: number, parameterName: ParameterName, value: ParameterModifier, phase?: number) {
    // console.log(
    //   `CalculationController.calculate(method=${method}, cardIndex=${cardIndex}, parameterName=${parameterName}, value=${value}, phase=${phase})`
    // );

    const newResult = Calculator.calculate(this.getCurrentResult(method), method, cardIndex, parameterName, value, phase);

    if (newResult && newResult.method === method) {
      this.setCurrentResult(method, newResult);
      const analyticsLabel = `${parameterName}`;
      Analytics.log('calculation.parameter', analyticsLabel, value);
      Analytics.log('calculation.validity', newResult.validityState.severity, newResult.validityState.reason);
    } else {
      Analytics.error(
        'error.calculation',
        `Failed to calculate. method:${method}, cardIndex=${cardIndex}, parameterName:${parameterName}, value:${value}, phase:${phase}`
      );
    }

    return this.getCurrentResult(method);
  }
}

export default CalculationController.instance;
